import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import type { EditPostModalProps } from "@circle-react/components/QuickPost/types";
import { EditPostWrapper } from "@circle-react/components/QuickPostV3/EditPostWrapper";
import { useModalClose } from "@circle-react/components/QuickPostV3/hooks/useModalClose";
import { LegacyEditorPortalLayeringStyles } from "@circle-react/components/QuickPostV3/LegacyEditorPortalLayeringStyles";
import { useQuickPostV3ModalStore } from "@circle-react/components/QuickPostV3/store";
import { PostsDetailsContextProvider } from "@circle-react/contexts/postsDetailsContext";
import { SpacesContextProvider } from "@circle-react/contexts/spacesContext";
import { useSmScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { Modal } from "@circleco/compass/components/Modal";
import { useEffect } from "react";

const EditPostV3ModalComponent = ({
  post,
  onPostChange,
  onSubmitSuccess,
  shouldSkipRedirectAfterSubmit,
}: EditPostModalProps) => {
  const modal = useModal();
  const { closeModal, forceClose, handleOpenChange, isOpen } = useModalClose();
  const reset = useQuickPostV3ModalStore(state => state.reset);
  const isFullscreen = useQuickPostV3ModalStore(state => state.isFullscreen);
  const isSmScreen = useSmScreenMediaQuery();
  const modalSize = isFullscreen || isSmScreen ? "full-screen" : "lg";

  useEffect(() => {
    if (modal.visible) reset();
  }, [modal.visible, reset]);

  return (
    <Modal.Root open={isOpen} onOpenChange={handleOpenChange} size={modalSize}>
      <LegacyEditorPortalLayeringStyles active={modal.visible} />
      <SpacesContextProvider>
        <PostsDetailsContextProvider
          perPagePostIds={[[post.id]]}
          queryOptions={{ gcTime: 0 }}
        >
          <EditPostWrapper
            onForceClose={forceClose}
            onRequestClose={closeModal}
            post={post}
            onPostChange={onPostChange}
            onSubmitSuccess={onSubmitSuccess}
            shouldSkipRedirectAfterSubmit={shouldSkipRedirectAfterSubmit}
          />
        </PostsDetailsContextProvider>
      </SpacesContextProvider>
    </Modal.Root>
  );
};

export const EditPostV3Modal = ModalManager.create(
  (props: EditPostModalProps) => <EditPostV3ModalComponent {...props} />,
);
